/* unplugin-vue-components disabled */import script from "./StagePropsReviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StagePropsReviewCard.vue?vue&type=script&setup=true&lang=js"

import "./StagePropsReviewCard.vue?vue&type=style&index=0&id=4726ad66&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4726ad66"]])

export default __exports__